import React, { useEffect } from "react";
import { getForm, postForm, uploadFiles, getMerchant, getMdaMerchant, getMdaForm } from "../apis/formApi";
import { getFormName } from "../utils/constants";
import { removeUniqueFieldName, suffix } from "../utils/functions/handleUniqueFieldName";
import _uniqueId from 'lodash/uniqueId';
import { compareDate } from "../utils/functions/compareDate";

const useForm = () => {
  const [fetching, setFetching] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [merchant, setMerchant] = React.useState(null);
  const [error, setError] = React.useState(null);

  const [submitData, setSubmitData] = React.useState(null);
  const [submitError, setSubmitError] = React.useState(null);
  const [formExpired, setFormExpired] = React.useState(false);

  const fetch = async () => {
    setFetching(true);
    const [merchantResult, result] = await Promise.all([
      await getMerchant(),
      await getForm({ name: getFormName() }),
    ]);
    setFetching(false);
    if (!result.ok) {
      return setError("The Form you requested does not exist");
    }
    if (!result.data.success) {
      return setError(result?.data?.data?.message || "");
    }
    if (
      result.data.success &&
      result.data.data &&
      result.data.data.length === 0
    ) {
      return setError("The Form you requested does not exist");
    }

    result?.data?.data?.forEach( item => {
      if(item?.end_date) {
        setFormExpired(compareDate(item.end_date, "<"))
      }

      // item?.form_fields?.forEach(field => {
      //   if(field.field_label){
      //     field.field_label = `${field.field_label}${_uniqueId(`--${suffix}--`)}`;
      //   }

      //   field?.field_items?.forEach((sub_field)=>{
      //     if(sub_field.field_label){
      //       sub_field.field_label = `${sub_field.field_label}${_uniqueId(`--${suffix}--`)}`;
      //     }
      //   })
      // })
    })
    
    let merchantData = merchantResult?.data?.merchant;
    if (merchantData) {      
      setMerchant(merchantData);
    }
   
    return setData(result.data);
  };

  const makeFormData = (data) => {
    const formData = new FormData();
    formData.append("ticket_id", data.ticket_id);
    formData.append("source", 'webform');
    data.files.forEach((file) => {
      formData.append("file[]", file.value, file.value.name);
    });

    return formData;
  };
 
  const submitForm = async ({ values, files = [], token, options, type, accessToken,selectedOption, merchant }) => {
  
    const params = new URLSearchParams(window.location.search);
    const { setSubmitting } = options;

    // const tenantId = params.get("tenantId");
    const auth_token = params.get("auth");

    const sso_token = params.get("accessToken");
   
    if (values.is_internal && !auth_token) {
      return setSubmitError(
        "Cannot validate form! Check the form and try again"
      );
    }
    if (values.is_internal && !sso_token) {
      return setSubmitError(
        "Cannot validate form! access token required for internal forms"
      );
    }

    const appToken = auth_token ? auth_token : token;
    const appAccessToken = sso_token ? sso_token : accessToken;
    const tenantId = merchant?.tenantId;

    // remove previously appended name suffix
    removeUniqueFieldName(values)
    
    setSubmitting(true);
    const result = await postForm({ data: values, token: appToken, accessToken:appAccessToken, type, selectedOption, tenantId});

    if (!result.ok) {
      console.log(result.originalError);
      setSubmitting(false);
      return setSubmitError("Unable to submit form");
    }

    if (result.data && !result.data.success) {
      return setSubmitError(result.data.data.message);
    }

    if (files.length > 0) {
      const formData = makeFormData({
        ticket_id: result.data.data.ticket_id,
        files,
      });

      const uploadResult = await uploadFiles({ token, data: formData });
      setSubmitting(false);

      if (!uploadResult.ok) {
        console.log(uploadResult.originalError);
        return setSubmitError("Unable to upload files");
      }

      if (uploadResult.data && !uploadResult.data.success) {
        console.log(uploadResult.originalError);
        return setSubmitError(uploadResult.data.message);
      }
    }

    return setSubmitData(result.data);
  };

  useEffect(() => {
    if (getFormName().match(/webform/g) !== null) {
      setError("The Form you requested does not exist");
    }
  }, [getFormName()]);

  return {
    fetching,
    loading,
    fetch,
    submitForm,
    error,
    submitData,
    submitError,
    data,
    merchant,
    formExpired
  };
};

export default useForm;
